export default "__VITE_ASSET__52cad5b7__"